import React from "react";
import {Row, Col} from "react-bootstrap";
import {title, titleText} from "./title.module.css";

export function Title({text, textStyle}) {
    return <Row className={`${title} ${textStyle}`}>
	<Col>	<h1 className={titleText}>{text}</h1></Col>
	</Row>;
}
